import { Controller } from "stimulus";

export default class extends Controller {
  static targets = [
    "amountTotal",
    "checkbox",
    "contributionTotal",
    "ordersCountTotal",
    "percentOfContributionTotal",
    "percentTotal",
    "totalContribution",
  ];

  connect() {
    this.update();
  }

  update() {
    let ordersCount = 0;
    let percentTotal = 0;
    let contributionTotal = 0;
    let amountTotal = 0;

    let currencyFormatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    });

    var percentFormatter = new Intl.NumberFormat("en-US", {
      style: "percent",
      minimumFractionDigits: 1,
      maximumFractionDigits: 1,
    });

    this.checkboxTargets.forEach((checkbox) => {
      if (checkbox.checked) {
        amountTotal += Number(checkbox.dataset.amount);
        ordersCount += Number(checkbox.dataset.ordersCount);
        contributionTotal += Number(checkbox.dataset.contribution);
        percentTotal += Number(checkbox.dataset.percent) / 100.0;
      }
    });

    console.log({ amountTotal });

    this.ordersCountTotalTarget.innerHTML = ordersCount;
    this.percentTotalTarget.innerHTML = percentFormatter.format(percentTotal);
    this.contributionTotalTarget.innerHTML =
      currencyFormatter.format(contributionTotal);
    this.amountTotalTarget.innerHTML = currencyFormatter.format(amountTotal);

    let totalContribution = Number(
      this.totalContributionTarget.innerHTML.replace(/[^0-9.-]+/g, "")
    );

    this.percentOfContributionTotalTarget.innerHTML = percentFormatter.format(
      contributionTotal / totalContribution
    );
  }
}
